import { render, staticRenderFns } from "./OperaRhCustomerServiceWindow.vue?vue&type=template&id=044dd763"
import script from "./OperaRhCustomerServiceWindow.vue?vue&type=script&lang=js"
export * from "./OperaRhCustomerServiceWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports